import React, { useState } from "react";

const DragSelectionWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [selectionBox, setSelectionBox] = useState({
    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,
  });

  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.button !== 0) return; // Only respond to left-click
    e.stopPropagation()
    e.preventDefault();

    const container = e.currentTarget.getBoundingClientRect();
    setSelectionBox({
      startX: e.clientX - container.left,
      startY: e.clientY - container.top,
      currentX: e.clientX - container.left,
      currentY: e.clientY - container.top,
    });

    setIsDragging(true);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    e.stopPropagation()

    const container = e.currentTarget.getBoundingClientRect();
    setSelectionBox((prev) => ({
      ...prev,
      currentX: Math.min(container.width, Math.max(0, e.clientX - container.left)),
      currentY: Math.min(container.height, Math.max(0, e.clientY - container.top)),
    }));
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const calculateBoxStyles = () => {
    const { startX, startY, currentX, currentY } = selectionBox;
    const left = Math.min(startX, currentX);
    const top = Math.min(startY, currentY);
    const width = Math.abs(currentX - startX);
    const height = Math.abs(currentY - startY);

    return { left, top, width, height };
  };

  const selectionStyles = calculateBoxStyles();

  return (
    <div
      className="drag-container relative w-full h-full overflow-hidden select-none"
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      {/* The app content */}
      {children}

      {/* Drag selection effect */}
      {isDragging && (
        <div
          className="absolute bg-blue-500 bg-opacity-20 border border-blue-600 pointer-events-none"
          style={{
            left: selectionStyles.left,
            top: selectionStyles.top,
            width: selectionStyles.width,
            height: selectionStyles.height,
          }}
        />
      )}
    </div>
  );
};

export default DragSelectionWrapper;
